// v0.5.0f — Server-generated audit reason preview.
//
// A2-571 (operator 2026-10-27: "We should not give options of free
// text only select dropdown"): the note is the server's, read-only.
// The old "Edit the note before confirming" textarea is gone.
import React from "react";
import { useTranslation } from "react-i18next";

export const InspectReasonPreview = ({
  decision, offender, country, manualBoxId,
  txnCount,
  reasonText,
  reasonLoading, reasonErr,
  confirmBusy, confirmErr, confirmPhase,
  flagged, flagBusy,
  onConfirmRoute, onConfirmFlag,
}) => {
  const { t } = useTranslation();
  if (!decision) return null;
  const cc = (country || "").toUpperCase();
  const isRouteDecision = decision === "real_rate_single"
    || decision === "bulk_route";
  return (
    <div
      data-testid={`inspect-reason-preview-${offender.rate}`}
      className="mt-4 pt-4 border-t border-slate-200 dark:border-slate-700 space-y-3"
    >
      <div className="text-[11px] uppercase tracking-widest text-slate-500 dark:text-slate-400 tabular-nums">
        {t("ui.country_return.reason_preview.title", { defaultValue: "Audit note (auto-suggested)" })}
      </div>
      {reasonLoading && (
        <div className="text-xs text-slate-500 dark:text-slate-400">
          {t("ui.country_return.reason_preview.generating", { defaultValue: "Generating note…" })}
        </div>
      )}
      {reasonErr && (
        <div
          data-testid={`inspect-reason-error-${offender.rate}`}
          className="text-xs text-rose-700 dark:text-rose-300"
        >
          {reasonErr}
        </div>
      )}
      {!reasonLoading && !reasonErr && (
        <div
          data-testid={`inspect-reason-readonly-${offender.rate}`}
          className="text-xs leading-relaxed p-3 rounded-md bg-slate-100 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100"
        >
          {reasonText}
        </div>
      )}
      {!reasonLoading && !reasonErr && (
        <div className="flex flex-wrap gap-2 items-center">
          <div className="flex-1" />
          {confirmErr && (
            <span
              data-testid={`inspect-confirm-error-${offender.rate}`}
              className="text-[11px] text-rose-700 dark:text-rose-300"
            >
              {confirmErr}
            </span>
          )}
          {isRouteDecision && (
            <button
              type="button"
              data-testid={`inspect-confirm-route-${offender.rate}`}
              data-resolution-class="self-resolve"
              data-resolution-endpoint="POST /api/runs/calc/{calc_id}/txn-override/async"
              onClick={onConfirmRoute}
              disabled={confirmBusy || reasonText.trim().length < 20}
              className="text-xs font-bold px-4 py-2 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {confirmBusy
                ? `${t("ui.country_return.reason_preview.saving", { defaultValue: "Saving…" })} ${confirmPhase ? `(${confirmPhase})` : ""}`.trim()
                : t("ui.country_return.reason_preview.confirm_assign", { n: txnCount, cc, box: manualBoxId, defaultValue: `▶ Confirm — assign ${txnCount} to ${cc} Box ${manualBoxId}` })}
            </button>
          )}
          {!isRouteDecision && (
            <button
              type="button"
              data-testid={`inspect-confirm-flag-${offender.rate}`}
              data-resolution-class="recordkeeping"
              data-resolution-endpoint="POST /api/calc/{calc_id}/rate-table-drift-flags"
              onClick={onConfirmFlag}
              disabled={flagBusy || flagged}
              className="text-xs font-bold px-4 py-2 rounded-md bg-rose-600 hover:bg-rose-700 text-white disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {flagBusy
                ? t("ui.country_return.reason_preview.reporting", { defaultValue: "Reporting…" })
                : flagged
                  ? t("ui.country_return.inspect.reported", { defaultValue: "✓ Reported" })
                  : t("ui.country_return.reason_preview.confirm_report", { cc, defaultValue: `▶ Confirm — report to maintainer (defers ${cc} filing)` })}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default InspectReasonPreview;
